import React, { useContext, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";

import MomentsUser from "../../components/MomentsUser";
// import MomentsQueues from "../../components/MomentsQueues";

import MainHeader from "../../components/MainHeader";
import {
  Grid,
  Paper,
  FormControl,
  Select,
  MenuItem,
  TextField,
  InputAdornment,
  Typography,
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import ForbiddenPage from "../../components/ForbiddenPage";
import { AuthContext } from "../../context/Auth/AuthContext";
import { i18n } from "../../translate/i18n";
import { AEROS, stateText } from "../../styles/aerosTokens";

const useStyles = makeStyles((theme) => ({
  container: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    paddingLeft: "5px",
    maxWidth: "100%",
  },
  boardArea: {
    padding: "24px 12px",
    minHeight: 0,
  },
  mainPaper: {
    display: "flex",
    padding: theme.spacing(1),
    overflowY: "scroll",
    ...theme.scrollbarStyles,
    alignItems: "center",
  },
  fixedHeightPaper: {
    padding: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    height: 100,
  },
  chatPapper: {
    display: "flex",
    height: "100%",
  },
  contactsHeader: {
    display: "flex",
    flexWrap: "wrap",
    padding: "0px 6px 6px 6px",
  },
  headerRow: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    minHeight: 60,
    gap: 12,
    width: "100%",
    paddingTop: 12,
    paddingBottom: 10,
    marginBottom: 6,
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  titleBlock: {
    minWidth: 220,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  pageTitle: {
    fontFamily: AEROS.fontDisplay,
    fontSize: 16,
    fontWeight: 700,
    letterSpacing: "-0.02em",
    color: theme.palette.text.primary,
    margin: 0,
    lineHeight: 1.3,
  },
  titleRow: {
    display: "flex",
    alignItems: "center",
    gap: 10,
  },
  livePill: {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    padding: "2px 10px",
    borderRadius: 999,
    fontSize: 11,
    fontWeight: 700,
    backgroundColor:
      theme.palette.type === "light"
        ? "rgba(4,120,87,0.10)"
        : "rgba(52,211,153,0.10)",
    color: stateText(theme, AEROS.success, "success"),
  },
  liveDot: {
    width: 6,
    height: 6,
    borderRadius: "50%",
    backgroundColor: AEROS.success,
  },
  subtitle: {
    fontSize: 12,
    color: theme.palette.text.secondary,
    marginTop: 2,
  },
  headerRight: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    marginLeft: "auto",
    flexWrap: "wrap",
  },
  statsRow: {
    display: "flex",
    alignItems: "center",
    gap: 14,
    marginRight: 6,
    fontSize: 12,
    flexWrap: "wrap",
  },
  statLabel: {
    color: theme.palette.text.secondary,
    marginRight: 4,
  },
  statValue: {
    fontWeight: 700,
    fontVariantNumeric: "tabular-nums",
  },
  statValuePrimary: {
    color: theme.palette.text.primary,
  },
  statValueWarning: {
    color: stateText(theme, AEROS.warning, "warning"),
  },
  statValueCyan: {
    color: stateText(theme, AEROS.cyan, "info"),
  },
  statDivider: {
    color: theme.palette.aeros.textTertiary,
  },
  searchField: {
    width: 210,
  },
  searchInput: {
    fontSize: 12.5,
    padding: "6.5px 10px",
  },
  searchIcon: {
    fontSize: 18,
    color: theme.palette.text.secondary,
  },
  queueSelectControl: {
    minWidth: 160,
  },
  queueSelectInput: {
    fontSize: 12.5,
    padding: "6.5px 12px",
  },
}));

const ChatMoments = () => {
  const classes = useStyles();
  const { user } = useContext(AuthContext);
  const [queueFilter, setQueueFilter] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [stats, setStats] = useState({
    emAtendimento: 0,
    aguardando: 0,
    naoLidas: 0,
  });

  return user.profile === "user" && user.allowRealTime === "disabled" ? (
    <ForbiddenPage />
  ) : (
    <MainHeader>
      <Grid
        style={{ width: "99.6%" }}
        container
        justifyContent="center"
        alignItems="flex-start"
      >
        <Grid xs={12} item>
          <div className={classes.headerRow}>
            <div className={classes.titleBlock}>
              <div className={classes.titleRow}>
                <Typography className={classes.pageTitle}>
                  {i18n.t("servicePanel.allowRealTime")}
                </Typography>
                <span className={classes.livePill}>
                  <span className={classes.liveDot} />
                  Tempo real
                </span>
              </div>
              <div className={classes.subtitle}>
                {i18n.t("servicePanel.subtitle")}
              </div>
            </div>
            <div className={classes.headerRight}>
              <div className={classes.statsRow}>
                <span>
                  <span className={classes.statLabel}>Em atendimento</span>
                  <span
                    className={`${classes.statValue} ${classes.statValuePrimary}`}
                  >
                    {stats.emAtendimento}
                  </span>
                </span>
                <span className={classes.statDivider}>·</span>
                <span>
                  <span className={classes.statLabel}>Aguardando</span>
                  <span
                    className={`${classes.statValue} ${classes.statValueWarning}`}
                  >
                    {stats.aguardando}
                  </span>
                </span>
                <span className={classes.statDivider}>·</span>
                <span>
                  <span className={classes.statLabel}>Não lidas</span>
                  <span
                    className={`${classes.statValue} ${classes.statValueCyan}`}
                  >
                    {stats.naoLidas}
                  </span>
                </span>
              </div>
              <FormControl
                variant="outlined"
                className={classes.queueSelectControl}
              >
                <Select
                  value={queueFilter}
                  onChange={(e) => setQueueFilter(e.target.value)}
                  displayEmpty
                  inputProps={{ className: classes.queueSelectInput }}
                >
                  <MenuItem value="">
                    {i18n.t("financial.queues")}: Todas
                  </MenuItem>
                  {(user.queues || []).map((queue) => (
                    <MenuItem key={queue.id} value={queue.id}>
                      {queue.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <TextField
                variant="outlined"
                className={classes.searchField}
                placeholder={i18n.t("momentsUser.searchPlaceholder")}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                InputProps={{
                  classes: { input: classes.searchInput },
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon className={classes.searchIcon} />
                    </InputAdornment>
                  ),
                }}
              />
            </div>
          </div>
        </Grid>
        <Grid style={{ width: "100%" }} item>
          {/* Sem `Paper` em volta: no mockup as colunas ficam soltas sobre o
              fundo da página; a moldura extra criava um card dentro do card. */}
          <div className={classes.boardArea}>
            <MomentsUser
              queueFilter={queueFilter}
              searchTerm={searchTerm}
              onStatsChange={setStats}
            />
          </div>
        </Grid>
      </Grid>
    </MainHeader>
  );
};

export default ChatMoments;
